import { membershipStatusSchema } from 'app/src/msw/membership/schemas/enums'
import { familyMembersSchema as userFamilyMemberSchema } from 'app/src/msw/membership/schemas/familyMembers'
import { prizeGroupSchema } from 'app/src/msw/membership/schemas/prize'
import { signatureSchema } from 'app/src/msw/membership/schemas/signature'
import { MembershipInfo } from 'app/src/services/welfareportal/membership-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const additionalInfoGroupSchema: z.ZodType<MembershipInfo['additionalInfoGroup']> = z.record(
  z.string(),
  z.object({
    signature: signatureSchema,
    data: z.record(z.string(), z.string()),
  }),
) as z.ZodType<MembershipInfo['additionalInfoGroup']>

export const membershipInfoSchema: z.ZodType<MembershipInfo> = z.object({
  tenantId: z.string().max(55),
  userId: z.string().max(255),
  userEmail: z
    .string()
    .max(255)
    .regex(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/),
  userIban: z
    .string()
    .max(255)
    .regex(/^(it|IT)[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/)
    .optional(),
  allowUserIbanEditing: z.boolean().optional(),
  userFiscalCode: z
    .string()
    .max(16)
    .regex(
      /^[A-Za-z]{6}[0-9LMNPQRSTUVlmnpqrstuv]{2}[AEBHCLDMPRSTabcdehlmprst]{1}[0-9LMNPQRSTUVlmnpqrstuv]{2}[A-Za-z]{1}[0-9LMNPQRSTUVlmnpqrstuv]{3}[A-Za-z]{1}$/,
    ),
  userRegistrationNumber: z.string().max(255),
  userFamilyMembers: z.array(userFamilyMemberSchema).optional(),
  userFamilyMembersPrivacyTemplateURL: z.string().max(500).optional(),
  companyPrize: z.array(prizeGroupSchema).optional(),
  status: membershipStatusSchema,
  firstMembershipAt: z.string().datetime().optional(),
  welfarePercentage: z.number().min(0).max(100),
  welfareAmount: z.number().min(0).max(999999.99).optional(),
  bonusAmount: z.number().min(0).max(999999.99),
  taxPercentage: z.number().min(0).max(100),
  inpsPercentage: z.number().min(0).max(100),
  additionalInfoGroup: additionalInfoGroupSchema.optional(),
})
